/**
 * @param pageSource
 * @param el
 * @param url An optional URL to be used when el isn't an <a> and doesn't have
 * an href
 */
// Used by lots of JS, including sharebar.js
window.getTafEmail = function (pageSource, el, url) {
    if (isMobileView()) {
        dcAnalytics.trackEventGA([pageName, 'TellAFriend', 'Open']);
        window.open(el.href + '&pageSource=' + pageName);
        return;
    }
    if ($('#tellAFriendIframe').length === 0) {
        $('body').prepend('<div id="lightboxTellAFriend" class="js-lightbox-tell-a-friend"><iframe scrolling="no" id="tellAFriendIframe" name="tellAFriendIframe" class="js-tell-a-friend-iframe" width="85%" frameborder="0"></iframe></div>');
        $('.js-lightbox-tell-a-friend').css('display', 'none');
        $('.js-lightbox-tell-a-friend .js-tell-a-friend-iframe').css({ width: '100%', 'background-color': '#ffffff' });
    }
    pageSource = pageSource || pageName;
    if ($(el).attr('data-page-source')) {
        pageSource = $(el).attr('data-page-source');
    }
    const targetUrl = el.href || url;
    if (window.oldTAF) {
        document.getElementById('tellAFriendIframe').style.height = '1700px';
        document.getElementById('tellAFriendIframe').src = targetUrl.replace('.html', '_b.html') + '&pageSource=' + pageSource;
    } else if (window.oldNewTAF) {
        document.getElementById('tellAFriendIframe').style.height = '750px';
        document.getElementById('tellAFriendIframe').src = targetUrl.replace('.html', '_c.html') + '&pageSource=' + pageSource;
    } else {
        document.getElementById('tellAFriendIframe').style.height = '750px';
        document.getElementById('tellAFriendIframe').src = targetUrl + '&pageSource=' + pageSource;
    }
    showLightbox(pageName, 'TellAFriend');
};

// Used by lots of JS, including sharebar.js and helpers.js
// If we move those into Rollup, we might be able to make this a module
window.getTafURL = function (id, proposalId) {
    if (id == 'Challenge') {
        return secureBaseURL + 'donors/send_topgiving.html?challengeId=' + challengeId;
    } else if (id == 'Leaderboard') {
        return secureBaseURL + 'donors/send_topgiving.html?category=' + encodeURIComponent(getParameterByName('category'));
    } else if (id == 'Motherboard') {
        return secureBaseURL + 'donors/send_topgiving.html?motherboardId=' + encodeURIComponent(getParameterByName('motherboardId'));
    } else if (id == 'School') {
        return secureBaseURL + 'donors/share_schoolpage.html?school=' + schoolId;
    } else if (id === 'TeacherStats') {
        return secureBaseURL + 'donors/share_teacher_stats.html?teacher=' + teacherStats.teacherId;
    } else if (id === 'EssentialsList') {
        // We pass the teacher ID as the second argument in this case.
        return secureBaseURL + 'donors/share-essentials-list.html?teacherId=' + proposalId;
    } else if (typeof proposalId !== 'undefined' && proposalId != '') {
        return secureBaseURL + 'donors/send_friend.html?sharetype=proposal&proposalId=' + proposalId + '&lightbox=' + id;
    } else {
        return secureBaseURL + 'donors/send_friend.html?sharetype=proposal&proposalId=' + id;
    }
};

// Used by launch_TAF_frag.jspf
window.launchTAF = function (pageName, id) {
    getTafEmail(pageName, { href: getTafURL(id) });
    return returnFalse();
};
